export interface Instructor {
    user_name: string;
    email: string | null;
}

export interface InstructorWithEmail extends Instructor {
    email: string;
}

export interface ClassWithInstructors {
    class_name: string;
    class_uuid: string;
    meeting_id: string;
    starting_at?: string;
    ending_at?: string;
    instructors: Instructor[];
}

export enum Status {
    INITIAL = 'INITIAL',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR'
}

export interface Statuses {
    fetchClasses: Status;
}

export interface Option {
    label: string;
    email: string;
}

export enum DirectionOption {
    ASCENDING = 'asc',
    DESCENDING = 'desc'
}

export type Direction = undefined | DirectionOption;

export enum SortOption {
    NAME = 'NAME',
    INSTRUCTOR = 'INSTRUCTOR',
    DATES = 'DATES'
}

export type SortBy = undefined | SortOption;
